import { get } from "./base";

export async function getNewsList(pageIndex) {
    let params = {
        pageNum: pageIndex == null ? 1 : pageIndex,
        pageSize: 10
    }
    let respObj = await get("/edu-classroom/platforminformation/infolist", params);
    if (respObj != false) {
        // 处理接口数据
        let newsList = [];
        for (const newsItem of respObj.list) {
            newsList.push({
                img: newsItem.headimg,
                title: newsItem.title,
                desc: newsItem.summary,
                date: newsItem.newsTime,
                read: newsItem.views,
                id: newsItem.id
            });
        }
        return {
            total: respObj.total,
            news: newsList,
        };
    } else {
        return {
            total: 0,
            news: [],
        }
    }
}
